"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateMobileNumber = exports.getPlaceholderByCountryCode = exports.getNumbersOnly = exports.getMobileNumberObject = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _libphonenumberJs = require("libphonenumber-js");

var _examplesMobile = _interopRequireDefault(require("libphonenumber-js/examples.mobile.json"));

var _reactInputMask = _interopRequireDefault(require("react-input-mask"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _TextField = _interopRequireWildcard(require("../TextField"));

var _MobileNumberField = _interopRequireDefault(require("./MobileNumberField.proptypes"));

var _constant = require("./constant");

var _excluded = ["accessible", "theme", "customProperties", "translation", "countryCode", "label", "value", "onFocus", "onChange", "onBlur", "isMobile"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var checkOveridePadding = function checkOveridePadding(countryCode) {
  var overidePlaceholder = _constant.OVERRIDE_PAD_PER_COUNTRY.find(function (placeholder) {
    return placeholder.country === countryCode.toUpperCase();
  });

  return overidePlaceholder ? overidePlaceholder.placeholder : null;
};

var getPlaceholderByCountryCode = function getPlaceholderByCountryCode(countryCode, isTemplate) {
  var exampleNumber = (0, _libphonenumberJs.getExampleNumber)(countryCode, _examplesMobile.default);

  if (!exampleNumber) {
    return '';
  }

  if (!isTemplate) {
    return exampleNumber.format('NATIONAL', {
      nationalPrefix: false
    });
  }

  var hasOverridePadding = checkOveridePadding(countryCode);

  if (hasOverridePadding) {
    return hasOverridePadding;
  }

  return exampleNumber.format('NATIONAL', {
    nationalPrefix: false
  }).replace(/[0-9]/g, '#');
};

exports.getPlaceholderByCountryCode = getPlaceholderByCountryCode;

var getNumbersOnly = function getNumbersOnly() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.replace(/[^0-9.]/g, '');
}; // Returns `true` if the validation is accepted


exports.getNumbersOnly = getNumbersOnly;

var customValidation = function customValidation(regex, value) {
  if (!regex || !value) return true;
  return new RegExp(regex, 'g').test(value);
};
/* istanbul ignore next */


var validateMobileNumber = function validateMobileNumber(value) {
  var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var isValidationRequired = countryCode && !_constant.EXEMPTED_COUNTRY_PHONE_CODES.includes(countryCode);

  if (!isValidationRequired) {
    return;
  }

  var MobilePhoneLib = new _libphonenumberJs.AsYouType(countryCode);
  var inputVal = getNumbersOnly(value);
  MobilePhoneLib.input(inputVal);

  var overrideValidation = _constant.OVERRIDE_VALIDATION_PER_COUNTRY.find(function (placeholder) {
    return placeholder.country === countryCode.toUpperCase();
  });

  if (overrideValidation) {
    /* istanbul ignore next */
    // eslint-disable-next-line consistent-return
    return value && !customValidation(overrideValidation.regex, inputVal);
  }
  /* istanbul ignore next */
  // eslint-disable-next-line consistent-return


  return value && !MobilePhoneLib.isValid();
};

exports.validateMobileNumber = validateMobileNumber;

var getMobileNumberObject = function getMobileNumberObject(value, countryCode) {
  var MobilePhoneLib = new _libphonenumberJs.AsYouType(countryCode);
  var inputVal = getNumbersOnly(value);
  MobilePhoneLib.input(inputVal);
  return MobilePhoneLib;
};

exports.getMobileNumberObject = getMobileNumberObject;

var MobileNumberField = function MobileNumberField(_ref) {
  var accessible = _ref.accessible,
      theme = _ref.theme,
      customProperties = _ref.customProperties,
      translation = _ref.translation,
      countryCode = _ref.countryCode,
      label = _ref.label,
      value = _ref.value,
      onFocus = _ref.onFocus,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      isMobile = _ref.isMobile,
      restTextFieldProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var placeholder = getPlaceholderByCountryCode(countryCode);
  var templateMask = getPlaceholderByCountryCode(countryCode, true);

  var MaskedInput = function MaskedInput(props) {
    return /*#__PURE__*/_react.default.createElement(_reactInputMask.default, (0, _extends2.default)({}, props, {
      formatChars: {
        '#': '[0-9]'
      },
      mask: templateMask,
      palceholder: placeholder,
      maskChar: null
    }), function (inputProps) {
      return /*#__PURE__*/_react.default.createElement(_TextField.StyledInput, (0, _extends2.default)({}, inputProps, {
        inputMode: "numeric"
      }));
    });
  };

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, (0, _extends2.default)({
    accessible: accessible,
    theme: theme,
    customProperties: customProperties,
    label: label,
    placeholder: placeholder,
    value: value,
    onFocus: onFocus,
    onChange: onChange,
    onBlur: onBlur,
    countryCode: countryCode,
    inputComponent: MaskedInput,
    type: isMobile ? 'number' : 'text'
  }, restTextFieldProps)));
};

MobileNumberField.propTypes = _MobileNumberField.default.PropTypes;
MobileNumberField.defaultProps = _MobileNumberField.default.DefaultProps;
var _default = MobileNumberField;
exports.default = _default;